import React, { useRef, useState } from 'react';
import {
    Box, Typography, Grid, Table, TableBody, TableCell, TableHead, TableRow, Button,
    Divider
} from '@mui/material';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';



const PurchaseOrderReport = ({ poData }) => {
    const poRef = useRef();
    const [fontSize, setFontSize] = useState(10); // default font size in px

    const handleDownload = async () => {
        const input = poRef.current;

        const canvas = await html2canvas(input, {
            scale: 2,
            useCORS: true,
            backgroundColor: '#fff',
        });

        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('l', 'mm', 'a4'); // Landscape mode

        const pdfWidth = pdf.internal.pageSize.getWidth();   // 297mm
        const pdfHeight = pdf.internal.pageSize.getHeight(); // 210mm

        const imgWidth = pdfWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let heightLeft = imgHeight;
        let position = 0;

        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;

        while (heightLeft > 0) {
            position -= pdfHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;
        }

        pdf.save('Purchase Order Report - # ' + poData.purchaseOrderNumber + '.pdf');
    };



    const totalsRow = poData.products.reduce(
        (acc, item) => {
            acc.qty += item.quantity;
            acc.amount += item.amount;
            acc.cgst += item.cgst_amount;
            acc.sgst += item.sgst_amount;
            acc.igst += item.igst_amount;
            acc.total += item.total;
            return acc;
        },
        { qty: 0, amount: 0, cgst: 0, sgst: 0, igst: 0, total: 0 }
    );

    const ones = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
        'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen',
        'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    // const numToWords = (num) => {
    //     if (num === 0) return 'Zero';
    //     if (num < 20) return ones[num];
    //     if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + ones[num % 10] : '');
    //     if (num < 1000) return ones[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + numToWords(num % 100) : '');
    //     if (num < 100000) return numToWords(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + numToWords(num % 1000) : '');
    //     if (num < 10000000) return numToWords(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + numToWords(num % 100000) : '');
    //     return numToWords(Math.floor(num / 10000000)) + ' Crore' + (num % 10000000 ? ' ' + numToWords(num % 10000000) : '');
    // };
    const numToWords = (num) => {
  if (typeof num !== 'number' || isNaN(num)) return 'Zero'; // 🔒 Fallback
  if (num === 0) return 'Zero';
  if (num < 20) return ones[num];
  if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + ones[num % 10] : '');
  if (num < 1000) return ones[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + numToWords(num % 100) : '');
  if (num < 100000) return numToWords(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + numToWords(num % 1000) : '');
  if (num < 10000000) return numToWords(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + numToWords(num % 100000) : '');
  return numToWords(Math.floor(num / 10000000)) + ' Crore' + (num % 10000000 ? ' ' + numToWords(num % 10000000) : '');
};


    const convertToWords = (amount) => {
        const whole = Math.floor(amount);
        const paisa = Math.round((amount - whole) * 100);
       // const rupees = numToWords(whole).toUpperCase();
        const rupees = (numToWords(whole) || 'Zero').toUpperCase();

        const paisaWords = paisa > 0 ? ` AND ${numToWords(paisa).toUpperCase()} PAISA` : ' AND ZERO PAISA';
        return `*** ${rupees} RUPEES${paisaWords} ONLY`;
    };



    return (
        <Box p={2}  >
            {/* bgcolor="#f0f0f0" */}
            <Button variant="contained" color='secondary' onClick={handleDownload} sx={{ mb: 2 }}>
                Download PDF
            </Button>

            <Box
                ref={poRef}
                sx={{
                    width: '297mm',
                    minHeight: '210mm',
                    padding: '5mm',
                    backgroundColor: '#fff',
                    fontSize: `${fontSize}px`,
                    fontFamily: 'cambria',
                    color: '#000',
                    boxSizing: 'border-box',
                }}
            >
                {/* Company Header */}
                <Typography variant="h6" fontWeight="bold">PURCHASE ORDER</Typography>


                <Table size="small" sx={{
                    mt: 0.2, border: '0.25px solid #000', fontSize: `${fontSize}px`, '& td, & th': {
                        fontSize: `${fontSize}px`, // 👈 Specifically applies to all cells
                        padding: '2px',  // Optional: reduce padding for tighter layout
                    }
                }}>
                    <TableBody>


                        <TableRow>
                            <TableCell sx={{ border: '0.25px solid #000', verticalAlign: 'top', color: 'black' }}>
                                <Typography sx={{ fontWeight: 'bold', color: 'black', marginBottom: "5px" }}> {poData.company[0].company_name}</Typography>
                                {poData.company[0].address},{poData.company[0].city},{poData.company[0].state},{poData.company[0].state}-{poData.company[0].pin_code} <br />
                                <strong>GSTIN:</strong>{poData.company[0].gst_no} &nbsp; | &nbsp;
                                {/* <strong>State Code:</strong> 33 */}
                            </TableCell>
                            <TableCell sx={{ border: '0.25px solid #000', verticalAlign: 'top', color: 'black' }}>
                                <Typography sx={{ fontWeight: 'bold', color: 'black', fontSize: '11px' }}>Order No:{poData.purchaseOrderNumber} </Typography>
                                <Typography sx={{ fontWeight: 'bold', color: 'black', fontSize: '11px' }}>Order Date:{poData.date} </Typography>

                                <strong>Reference No.:</strong> {poData.referenceNumber} <br />
                                {/* <strong>ISO No:</strong> <br /> */}
                                <strong>Payment Terms:</strong>{poData.paymentTerms}<br />
                                <strong>Freight:</strong> {poData.fright}   | <strong>Exp. Del. Date:</strong> {poData.expectedDeliveryDate}<br />

                            </TableCell>
                        </TableRow>

                        {/* <TableRow>
                            <TableCell sx={{ border: '0.25px solid #000', verticalAlign: 'top', color: 'black' }}>
                                <strong>Ship To:</strong><br />
                                <strong> {poData.company[0].company_name}</strong><br />
                                {poData.company[0].address},{poData.company[0].city},{poData.company[0].state},{poData.company[0].state}-{poData.company[0].pin_code} <br />
                                <strong>State Code:</strong>  {poData.company[0].state}<br />
                                <strong>GSTIN:</strong> {poData.company[0].gst_no}
                            </TableCell>
                            <TableCell sx={{ border: '0.25px solid #000', verticalAlign: 'top', color: 'black' }}>
                                <strong>Supplier:</strong><br />
                                <strong>{poData.supplier[0].company_name}</strong> <br />
                                {poData.supplier[0].billing_address}<br />
                                <strong>State Code:</strong> {poData.supplier[0].billing_state_id}<br />
                                <strong>GSTIN:</strong> {poData.supplier[0].gst_number} | <strong>PAN No:</strong> {poData.supplier[0].pan_number}
                            </TableCell>
                        </TableRow> */}
                        <TableRow>
    {/* LEFT → SUPPLIER */}
    <TableCell sx={{ border: '0.25px solid #000', verticalAlign: 'top', color: 'black' }}>
        <strong>Supplier:</strong><br />
        <strong>{poData.supplier[0].company_name}</strong> <br />
        {poData.supplier[0].billing_address}<br />
        <strong>State Code:</strong> {poData.supplier[0].billing_state_id}<br />
        <strong>GSTIN:</strong> {poData.supplier[0].gst_number} | <strong>PAN No:</strong> {poData.supplier[0].pan_number}
    </TableCell>

    {/* RIGHT → SHIP TO */}
    <TableCell sx={{ border: '0.25px solid #000', verticalAlign: 'top', color: 'black' }}>
        <strong>Ship To:</strong><br />
        <strong>{poData.company[0].company_name}</strong><br />
        {poData.company[0].address},{poData.company[0].city},{poData.company[0].state},{poData.company[0].state}-{poData.company[0].pin_code} <br />
        <strong>State Code:</strong> {poData.company[0].state}<br />
        <strong>GSTIN:</strong> {poData.company[0].gst_no}
    </TableCell>
</TableRow>

                    </TableBody>
                </Table>



                {/* Table */}
                <Table size="small" sx={{
                    mt: 0.1, border: '0.25px solid #000', fontSize: `${fontSize}px`,
                    '& td, & th': {
                        fontSize: `${fontSize}px`, // 👈 Specifically applies to all cells
                        padding: '2px',  // Optional: reduce padding for tighter layout
                        justifyContent: 'center',
                        textAlign: 'center',
                        color: 'black'
                    }
                }}>
                    <TableHead>
                        <TableRow>
                            {/* Empty cells for the previous columns */}
                            <TableCell rowSpan={2} sx={{ border: '0.25px solid #000', fontWeight: 'bold' }}>S No</TableCell>
                            <TableCell rowSpan={2} sx={{ border: '0.25px solid #000', fontWeight: 'bold' }}>Code</TableCell>
                            <TableCell rowSpan={2} sx={{ border: '0.25px solid #000', fontWeight: 'bold' }}>Description</TableCell>
                            <TableCell rowSpan={2} sx={{ border: '0.25px solid #000', fontWeight: 'bold' }}>HSN/SAC</TableCell>
                            <TableCell rowSpan={2} sx={{ border: '0.25px solid #000', fontWeight: 'bold' }}>UOM</TableCell>
                            <TableCell rowSpan={2} sx={{ border: '0.25px solid #000', fontWeight: 'bold' }}>Qty</TableCell>
                            <TableCell rowSpan={2} sx={{ border: '0.25px solid #000', fontWeight: 'bold' }}>Rate</TableCell>
                            <TableCell rowSpan={2} sx={{ border: '0.25px solid #000', fontWeight: 'bold' }}>Amount</TableCell>

                            {/* Tax parent headers */}
                            <TableCell colSpan={2} sx={{ border: '0.25px solid #000', fontWeight: 'bold', textAlign: 'center' }}>CGST</TableCell>
                            <TableCell colSpan={2} sx={{ border: '0.25px solid #000', fontWeight: 'bold', textAlign: 'center' }}>SGST</TableCell>
                            <TableCell colSpan={2} sx={{ border: '0.25px solid #000', fontWeight: 'bold', textAlign: 'center' }}>IGST</TableCell>

                            <TableCell rowSpan={2} sx={{ border: '0.25px solid #000', fontWeight: 'bold' }}>Total</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell sx={{ border: '0.25px solid #000', fontWeight: 'bold' }}>Rate</TableCell>
                            <TableCell sx={{ border: '0.25px solid #000', fontWeight: 'bold' }}>Amt</TableCell>
                            <TableCell sx={{ border: '0.25px solid #000', fontWeight: 'bold' }}>Rate</TableCell>
                            <TableCell sx={{ border: '0.25px solid #000', fontWeight: 'bold' }}>Amt</TableCell>
                            <TableCell sx={{ border: '0.25px solid #000', fontWeight: 'bold' }}>Rate</TableCell>
                            <TableCell sx={{ border: '0.25px solid #000', fontWeight: 'bold' }}>Amt</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>

                        {poData.products.map((item, idx) => (
                            <TableRow key={idx}>
                                <TableCell sx={{ border: '0.25px solid #000' }}>{idx + 1}</TableCell>
                                 <TableCell sx={{ border: '0.25px solid #000' }}>{item.description}</TableCell>
                                <TableCell sx={{ border: '0.25px solid #000' }}>{item.code}</TableCell>
                               
                                <TableCell sx={{ border: '0.25px solid #000' }}>{item.hsn || 0}</TableCell>
                                <TableCell sx={{ border: '0.25px solid #000' }}>{item.material_uom || ''}</TableCell>
                                <TableCell sx={{ border: '0.25px solid #000' }}>{item.quantity}</TableCell>
                                <TableCell sx={{ border: '0.25px solid #000' }}>{item.rate}</TableCell>
                                <TableCell sx={{ border: '0.25px solid #000' }}>{item.amount.toLocaleString()}</TableCell>

                                {/* CGST */}
                                <TableCell sx={{ border: '0.25px solid #000' }}>{item.cgst_rate}%</TableCell>
                                <TableCell sx={{ border: '0.25px solid #000' }}>{item.cgst_amount.toLocaleString()}</TableCell>

                                {/* SGST */}
                                <TableCell sx={{ border: '0.25px solid #000' }}>{item.sgst_rate}%</TableCell>
                                <TableCell sx={{ border: '0.25px solid #000' }}>{item.sgst_amount.toLocaleString()}</TableCell>

                                {/* IGST */}
                                <TableCell sx={{ border: '0.25px solid #000' }}>{item.igst_rate}%</TableCell>
                                <TableCell sx={{ border: '0.25px solid #000' }}>{item.igst_amount.toLocaleString()}</TableCell>

                                <TableCell sx={{ border: '0.25px solid #000' }}>{item.total.toLocaleString()}</TableCell>
                            </TableRow>
                        ))}

                        <TableRow>
                            <TableCell sx={{ border: '0.25px solid #000' }} colSpan={5}><strong>Total</strong></TableCell>
                            <TableCell sx={{ border: '0.25px solid #000' }}>{totalsRow.qty.toFixed(2)}</TableCell>
                            <TableCell sx={{ border: '0.25px solid #000' }} /> {/* Empty Rate cell */}
                            <TableCell sx={{ border: '0.25px solid #000' }}>{totalsRow.amount.toLocaleString()}</TableCell>

                            <TableCell sx={{ border: '0.25px solid #000' }} /> {/* CGST Rate */}
                            <TableCell sx={{ border: '0.25px solid #000' }}>{totalsRow.cgst.toLocaleString()}</TableCell>

                            <TableCell sx={{ border: '0.25px solid #000' }} /> {/* SGST Rate */}
                            <TableCell sx={{ border: '0.25px solid #000' }}>{totalsRow.sgst.toLocaleString()}</TableCell>

                            <TableCell sx={{ border: '0.25px solid #000' }} /> {/* IGST Rate */}
                            <TableCell sx={{ border: '0.25px solid #000' }}>{totalsRow.igst.toLocaleString()}</TableCell>

                            <TableCell sx={{ border: '0.25px solid #000' }}>{totalsRow.total.toLocaleString()}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>




                <Table size="small" sx={{
                    mt: 0.2, border: '0.25px solid #000', fontSize: `${fontSize}px`,
                    '& td, & th': {
                        fontSize: `${fontSize}px`, // 👈 Specifically applies to all cells
                        padding: '2px',  // Optional: reduce padding for tighter layout
                    }
                }}>
                    <TableBody>
                        <TableRow>
                            {/* Left: Label */}
                            <TableCell sx={{ border: '0.25px solid #000', fontWeight: 'bold', width: '70%', verticalAlign: 'top', color: 'black' }}>
                                Total Invoice Amount in Words:
                                <Typography fontSize={fontSize}>
                                    {/* *** ONE LAKH SEVENTY THOUSAND FIVE HUNDRED TWENTY RUPEES AND ZERO PAISA ONLY */}
                                    {convertToWords((
                                        totalsRow.total -
                                        Number(poData.discountValue.toFixed(2)) +
                                        Number(poData.adjustment.toFixed(2))
                                    ).toFixed(2))}
                                </Typography>

                            </TableCell>

                            {/* Right: Summary rows begin from here, merged into one tall cell */}
                            <TableCell rowSpan={2} sx={{ border: '0.25px solid #000', verticalAlign: 'top', padding: 0 }}>
                                <Table size="small" sx={{ width: '100%', color: 'black' }}>
                                    <TableBody>
                                        {[
                                            ['Total', totalsRow.amount.toLocaleString()],
                                             ['Discount', poData.discountValue.toFixed(2)],
                                            ['Total Amount Before Tax', totalsRow.amount.toLocaleString()],
                                            // ['GST Base Amount', totalsRow.amount.toLocaleString()],
                                            ['Add : CGST', totalsRow.cgst.toLocaleString()],
                                            ['Add : SGST', totalsRow.sgst.toLocaleString()],
                                            ['Add : IGST', totalsRow.igst.toLocaleString()],
                                            ['Tax Amount : GST', (totalsRow.cgst + totalsRow.sgst + totalsRow.igst).toLocaleString()],
                                            ['TDS Amount', poData.tdsValue.toFixed(2)],
                                           
                                            // ['Adjustment', poData.adjustment.toFixed(2)],
                                            ['Total Amount After Tax', (
                                                totalsRow.total -
                                                Number(poData.discountValue.toFixed(2)) +
                                                Number(poData.adjustment.toFixed(2))-
                                                Number(poData.tdsValue.toFixed(2)) 
                                            ).toFixed(2)],
                                        ].map(([label, value], index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ border: '0.25px solid #000', fontWeight: index === 9 ? 'bold' : 'normal', color: 'black' }}>
                                                    {label}
                                                </TableCell>
                                                <TableCell sx={{ border: '0.25px solid #000', fontWeight: index === 9 ? 'bold' : 'normal', color: 'black' }}>
                                                    ₹{value}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            {/* Left: Value in words */}
                            <TableCell sx={{ border: '0.25px solid #000', fontWeight: 'bold', color: 'black' }}>
                                .
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>

                <Table size="small" sx={{
                    mt: 0.2, border: '0.25px solid #000', fontSize: `${fontSize}px`,
                    '& td, & th': {
                        fontSize: `${fontSize}px`, // 👈 Specifically applies to all cells
                        padding: '1px',  // Optional: reduce padding for tighter layout
                    }
                }}>
                    <TableBody>
                        {/* Terms and Signature Stamp Box */}
                        <TableRow>
                            <TableCell sx={{ border: '0.25px solid #000', width: '75%', fontSize: `${fontSize}px`, color: 'black' }}>
                                <Typography fontWeight="bold" fontSize={fontSize + 1} >Other Terms & Conditions:</Typography>
                                <Typography fontSize={fontSize}>{poData.customerNotes}</Typography>
                            </TableCell>
                            <TableCell sx={{ border: '0.25px solid #000', width: '25%', verticalAlign: 'bottom', color: 'black' }}>
                                <Box sx={{ flexDirection: 'column', padding: 0 }}>
                                    {/* Top empty space (for signature/stamp) */}
                                    {/* <Box sx={{ flex: 1, borderBottom: '1px solid #000' }} /> */}

                                    {/* Company label */}
                                    <Box sx={{ textAlign: 'center', borderBottom: '1px solid #000', py: 0.5 }}>
                                        <Typography variant="body2" fontWeight="bold" fontSize={fontSize}>
                                            For {poData.company[0].company_name}
                                        </Typography>
                                    </Box>

                                    {/* Signature area */}
                                    <Box sx={{ textAlign: 'center', py: 1 }}>
                                        <Typography variant="body2" fontSize={fontSize}>[Signature Here]</Typography> {/* Optional placeholder */}
                                    </Box>


                                </Box>

                            </TableCell>
                        </TableRow>

                        {/* Signatures */}
                        <TableRow>
                            <TableCell sx={{
                                mt: 0.2, border: '0.25px solid #000', fontSize: `${fontSize}px`,
                                '& td, & th': {
                                    fontSize: `${fontSize}px`, // 👈 Specifically applies to all cells
                                    padding: '1px',  // Optional: reduce padding for tighter layout
                                    color: 'black',
                                }
                            }} colSpan={2}>
                                <Table size="small" sx={{ width: '100%' }}>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ border: '0.25px solid #000', width: '25%', textAlign: 'center' }}>
                                                <Typography fontWeight="bold" fontSize={fontSize}>Created By</Typography>
                                                <Typography fontSize={fontSize}>.</Typography>
                                            </TableCell>
                                            <TableCell sx={{ border: '0.25px solid #000', width: '25%', textAlign: 'center' }}>
                                                <Typography fontWeight="bold" fontSize={fontSize}>Verified By</Typography>
                                                <Typography fontSize={fontSize}>.</Typography>
                                            </TableCell>
                                            <TableCell sx={{ border: '0.25px solid #000', width: '25%', textAlign: 'center' }}>
                                                <Typography fontWeight="bold" fontSize={fontSize}>Approved By</Typography>
                                                <Typography fontSize={fontSize}>.</Typography>
                                            </TableCell>
                                            <TableCell sx={{ border: '0.25px solid #000', width: '25%', textAlign: 'center' }}>
                                                <Typography sx={{ mt: 2, fontWeight: "bold", fontSize: { fontSize } }}>Authorised Signatory</Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>

            </Box>
        </Box >
    );
};

export default PurchaseOrderReport;
